"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var Popup_1 = __importDefault(require("semantic-ui-react/dist/commonjs/modules/Popup"));
/**
 * A Tooltip component displays additional information about an element on the page, upon hover or focus.
 */
var Tooltip = /** @class */ (function (_super) {
    __extends(Tooltip, _super);
    function Tooltip() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Tooltip.prototype.render = function () {
        var _a = this.props, element = _a.element, content = _a.content, header = _a.header, event = _a.event, position = _a.position, size = _a.size, offset = _a.offset, flowing = _a.flowing, hoverable = _a.hoverable, className = _a.className, hideOnScroll = _a.hideOnScroll, open = _a.open, rest = __rest(_a, ["element", "content", "header", "event", "position", "size", "offset", "flowing", "hoverable", "className", "hideOnScroll", "open"]);
        return (React.createElement(Popup_1.default, __assign({}, rest, { trigger: element, content: content, header: header, on: event, position: position, size: size, offset: offset, flowing: flowing, hoverable: hoverable, hideOnScroll: hideOnScroll, open: open, className: this.genInputClass() })));
    };
    Tooltip.prototype.genInputClass = function () {
        var classString = 'ui tooltip';
        if (this.props.className) {
            classString += " " + this.props.className;
        }
        return classString;
    };
    Tooltip.defaultProps = {
        event: 'hover',
        size: 'small',
        position: 'top left',
        hideOnScroll: false,
        offset: '0, 0'
    };
    return Tooltip;
}(React.Component));
exports.default = Tooltip;
